import { render, staticRenderFns } from "./DiskSizeSelection.vue?vue&type=template&id=74e86ca0&scoped=true&"
import script from "./DiskSizeSelection.vue?vue&type=script&lang=js&"
export * from "./DiskSizeSelection.vue?vue&type=script&lang=js&"
import style0 from "./DiskSizeSelection.vue?vue&type=style&index=0&id=74e86ca0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e86ca0",
  null
  
)

export default component.exports